import { clsx } from 'clsx'
import { Card } from 'component/Card'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { ImageStore } from 'store/item/ImageStore'
import css from './ProductCard.module.scss'

type Props = {
  src: string | undefined
}

export const ProductCard = observer(({ src }: Props) => {
  const image = useMemo(() => new ImageStore(src), [src])
  const { source, ready, onLoad, onError } = image ?? {}

  return <Space center oh>
    {(!image || !ready) && <Card stub wide className={css.stub} />}
    {image && <Card className={clsx(!ready && css.hide)} tall>
      <Img className={css.image} src={source} onLoad={onLoad} onError={onError} />
    </Card>}
  </Space>
})
